import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Typography, Button, Grid, Box } from "@mui/material";
import CartItem from "./CartItem/CartItem";
import Link from "@mui/material/Link";
import { useTheme } from "@mui/material/styles";
import styles from "./styles";
var Cart = function (_a) {
    var cart = _a.cart, handleUpdateCartQty = _a.handleUpdateCartQty, handleRemoveFromCart = _a.handleRemoveFromCart, handleEmptyCart = _a.handleEmptyCart;
    var theme = useTheme();
    var classes = styles(theme);
    var navigate = useNavigate();
    var EmptyCart = function () { return (React.createElement(Typography, { variant: "subtitle1" },
        "Your cart is currently empty.",
        React.createElement("br", null),
        React.createElement(Link, { href: "/", sx: classes.link }, "Return to shop"))); };
    var FilledCart = function () { return (React.createElement(React.Fragment, null,
        React.createElement(Grid, { container: true, spacing: 3 }, cart.line_items.map(function (item) { return (React.createElement(Grid, { item: true, xs: 12, sm: 4, key: item.id },
            React.createElement(CartItem, { item: item, onUpdateCartQty: handleUpdateCartQty, onRemoveFromCart: handleRemoveFromCart }))); })),
        React.createElement(Box, { sx: classes.cardDetails },
            React.createElement(Typography, { variant: "h4" },
                "Subtotal: ",
                cart.subtotal.formatted_with_symbol),
            React.createElement("div", null,
                React.createElement(Button, { sx: classes.emptyButton, size: "large", type: "button", variant: "contained", color: "secondary", onClick: handleEmptyCart }, "Empty Cart"),
                React.createElement(Button, { sx: classes.checkoutButton, size: "large", type: "button", variant: "contained", color: "primary", onClick: function () { return navigate("/checkout"); } }, "Checkout"))))); };
    if (!cart.line_items)
        return "Loading...";
    return (React.createElement(Container, null,
        React.createElement(Box, { sx: classes.toolbar }),
        React.createElement(Typography, { sx: classes.title, variant: "h3" }, "Shopping Cart"),
        !cart.line_items.length ? React.createElement(EmptyCart, null) : React.createElement(FilledCart, null)));
};
export default Cart;
